export default "__VITE_ASSET__G_I_ZtSp__"